import { Container } from '../../../components/layout/Container';

import { ToolPageSubHeader } from '../../../components/layout/ToolPageLayout';

import { ComparateurFunnel } from '../../../components/tools/ComparateurFunnel';

import { HowToLd } from '../../../components/seo/jsonld/HowTo';

import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

import { MeshBackground } from '../../../components/motion/MeshBackground';

import { Reveal } from '../../../components/motion/Reveal';

import { Badge } from '../../../components/ui/badge';

import { ShieldCheck, Sparkles, Timer } from 'lucide-react';



export default function ComparateurDemarrerPage() {

  return (

    <div className="relative bg-paper">

      <ToolPageSubHeader

        toolLabel="Comparateur multi-fournisseurs B2B"

        backHref="/comparateur"

        backLabel="Comparateur"

        rightSlot={

          <span className="inline-flex items-center gap-1.5 rounded-full bg-stone-100 px-2.5 py-1 text-[11px] font-semibold text-stone-600">

            <Timer className="h-3 w-3" strokeWidth={2} />

            ~3 min

          </span>

        }

      />

      <MeshBackground variant="warm" intensity="soft" withGrid />

      <Container className="relative max-w-3xl pb-24 pt-12 md:pt-16">

        <Reveal>

          <Badge variant="ivory" size="lg" className="gap-2">

            <Timer className="h-3.5 w-3.5" /> 5 à 6 étapes · 3 minutes

          </Badge>

          <h1 className="mt-6 font-display text-display-2 font-bold leading-[0.96] tracking-tight3 text-balance text-ink md:text-display-1">

            Comparateur multi-fournisseurs B2B

          </h1>

          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-stone-600 md:text-xl">

            Courtier indépendant des fournisseurs d&apos;énergie — sans partenariat exclusif.

            Nous comparons toutes les offres électricité et gaz accessibles à votre profil

            d&apos;entreprise.

          </p>

          <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2 text-sm text-stone-500">

            <span className="inline-flex items-center gap-2">

              <ShieldCheck className="h-4 w-4 text-brand-700" />

              Données publiques officielles

            </span>

            <span className="inline-flex items-center gap-2">

              <Sparkles className="h-4 w-4 text-accent-600" />

              Comparaison sans partenariat

            </span>

            <span className="inline-flex items-center gap-2">

              <Timer className="h-4 w-4 text-stone-400" />

              Dossier conservé 30 jours

            </span>

          </div>

        </Reveal>



        <Reveal delay={0.15} className="mt-10">

          <ComparateurFunnel />

        </Reveal>



        <HowToLd

          name="Comparateur multi-fournisseurs B2B"

          description="Comparer les offres électricité et gaz pour entreprise en quelques étapes guidées."

          steps={[

            {

              name: "Identification de l'entreprise",

              text: 'Tapez votre raison sociale ou votre SIRET — récupération automatique des informations de votre entreprise.',

            },

            {

              name: 'Coordonnées de contact',

              text: 'Nom, prénom, e-mail professionnel et téléphone avec indicatif international.',

            },

            {

              name: 'Choix de l’énergie',

              text: 'Électricité, gaz ou les deux — comparaison adaptée à votre profil.',

            },

            {

              name: 'Usages déclarés',

              text: 'Selon votre secteur d’activité, quelques toggles rapides pour préciser vos équipements consommateurs (four, ECS, éclairage, climatisation…). Étape rapide et optionnelle.',

            },

            {

              name: 'Import des factures',

              text: 'Téléversez vos factures d’été et d’hiver (PDF ou photo) — ou demandez un rappel par e-mail.',

            },

            {

              name: 'Validation et suite',

              text: "Récapitulatif, consentement RGPD (protection des données), soumission. Un consultant vous recontacte sous 24h ouvrées.",

            },

          ]}

        />

        <BreadcrumbListLd

          items={[

            { name: 'Accueil', url: 'https://solutionecofrance.fr/' },

            { name: 'Tous les outils', url: 'https://solutionecofrance.fr/outils' },

            { name: 'Comparateur', url: 'https://solutionecofrance.fr/comparateur' },

            { name: 'Démarrer', url: 'https://solutionecofrance.fr/comparateur/demarrer' },

          ]}

        />

      </Container>

    </div>

  );

}

